module.exports = __webpack_public_path__ + "img/基米总额@2x.4eff5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/基米总额@2x.png
// module id = G4DI
// module chunks = 3